import{jsx as t}from"react/jsx-runtime";import{twMerge as e}from"tailwind-merge";import{smallIcons as r,mediumIcons as n,largeIcons as o,socialIcons as c}from"./SystemIcon.constants.js";function i(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function s(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},n=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(r).filter((function(t){return Object.getOwnPropertyDescriptor(r,t).enumerable})))),n.forEach((function(e){i(t,e,r[e])}))}return t}
/**
 * 시스템 아이콘을 표시하는 컴포넌트입니다.
 * 크기별(small, medium, large) 및 소셜 아이콘을 지원합니다.
 *
 * @param {Object} props - 컴포넌트 속성
 * @param {string} props.name - 아이콘의 이름 (예: 'small_close', 'medium_check', 'large_arrow')
 * @param {string} [props.testId] - 테스트를 위한 ID
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {boolean} [props.solid=false] - 아이콘을 실선으로 표시할지 여부
 * @param {Function} [props.onClick] - 클릭 이벤트 핸들러
 *
 * @example
 * // 기본 사용법
 * <SystemIcon name="small_close" />
 *
 * // 커스텀 클래스와 함께 사용
 * <SystemIcon
 *   name="medium_check"
 *   className="text-blue-500"
 *   solid={true}
 * />
 *
 * // 클릭 이벤트와 함께 사용
 * <SystemIcon
 *   name="large_arrow"
 *   onClick={() => console.log('아이콘 클릭됨')}
 *   testId="arrow-icon"
 * />
 */const l=({name:i,testId:l,className:a,solid:u=!1,onClick:m})=>{const f=i.split("_")[0],g=e("text-w-gray-900",a),b=e=>{if("small"===f){const n=r.get(i);return n&&/*#__PURE__*/t(n,s({},e))}if("medium"===f){const r=n.get(i);return r&&/*#__PURE__*/t(r,s({},e))}if("large"===f){const r=o.get(i);return r&&/*#__PURE__*/t(r,s({},e))}const l=c.get(i);return l&&/*#__PURE__*/t(l,s({},e))};return b&&/*#__PURE__*/t(b,{className:g,testId:l,solid:u,onClick:m})};export{l as SystemIcon};
